import { render, staticRenderFns } from "./VideoTopSection.vue?vue&type=template&id=70323798&scoped=true&"
import script from "./VideoTopSection.vue?vue&type=script&lang=js&"
export * from "./VideoTopSection.vue?vue&type=script&lang=js&"
import style0 from "./VideoTopSection.vue?vue&type=style&index=0&id=70323798&lang=scss&scoped=true&"
import style1 from "./VideoTopSection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70323798",
  null
  
)

export default component.exports